import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { handlePostRequest } from '../../service/PostTemplate';
import { endPoints } from '../../Config';
import { useNavigate } from 'react-router-dom';
import { handleGetRequest } from '../../service/GetTemplate';

const Branding = () => {
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [imagePath, setImagePath] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileError, setFileError] = useState('');
    const customerImageRef = useRef(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formik = useFormik({
        initialValues: {
            merchantId: '',
            BrandingImage: '',
            CreatedBy: ''
        },
        onSubmit: async (data) => {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const formData = new FormData();

            formData.append('merchantId', user?.data?.merchantId || '');
            formData.append('BrandingImage', selectedFile);
            formData.append('CreatedBy', user?.data?.userId || '');

            setLoadingBtn(true);
            const response = await dispatch(handlePostRequest(formData, endPoints.createMerchantBrandingImage, true));
            if (response?.status === 200) {
                formik.resetForm();
                setSelectedFile(null);
                getBrandImageById();
            }
            setLoadingBtn(false);
        }
    });

    const handleCustomerIcon = () => {
        customerImageRef.current.click();
    };

    const handleCustomerImageChange = (event) => {
        const file = event.target.files[0];
        const allowedTypes = ['image/jpeg', 'image/png'];
        const maxSize = 2 * 1024 * 1024; // 2MB

        setFileError('');
        setSelectedFile(null);
        formik.setFieldValue('BrandingImage', '');

        if (file) {
            if (!allowedTypes.includes(file.type)) {
                setFileError('Only PNG and JPEG formats are allowed.');
                return;
            }

            if (file.size > maxSize) {
                setFileError('File size must be less than 2MB.');
                return;
            }

            formik.setFieldValue('BrandingImage', file.name);
            setSelectedFile(file);
        }
    };

    const handleClick = () => {
        navigate('/view-Branding');
    };

    const getBrandImageById = async () => {
        setLoadingBtn(true);

        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const merchantId = user?.data?.merchantId;

        const response = await handleGetRequest(endPoints.getMerchantBrandingImageId(merchantId), true);
        if (response) {
            formik.setFieldValue('id', response?.data?.id);
            formik.setFieldValue('merchantId', response?.data?.merchantId);

            setImagePath(response?.data?.imagePath || null);
        }

        setLoadingBtn(false);
    };

    useEffect(() => {
        getBrandImageById();
    }, []);

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                <div className="col-12 md:col-8">
                    <div className="col-12 md:col-6">
                        <div className="mb-3">
                            <label htmlFor="image">
                                Upload Image <span style={{ color: 'red' }}>*</span>
                            </label>
                            <div className="file-input-container file-input-wrapper w-100" onClick={handleCustomerIcon}>
                                <input type="file" accept="image/*" style={{ display: 'none' }} ref={customerImageRef} onChange={handleCustomerImageChange} className="file-input-field" />
                                <input type="text" placeholder="Choose a file..." value={formik?.values?.BrandingImage} readOnly className="file-input-field" />
                            </div>
                            {fileError && <small className="p-error">{fileError}</small>}
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <p>Allowed formats: (png, jpeg) max size: 2MB.</p>
                <p>Request may take 24 hours to be reflected at web checkout page.</p>
                <p>You can upload image twice in 24 hours.</p>
            </div>

            <div className="flex justify-content-start mt-4 gap-2">
                <Button label="Upload" icon="pi pi-save" type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120 }} />
                <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120 }} onClick={handleClick} />
            </div>
            <div className="flex justify-content-between align-items-center mb-3">
                <p className="font-semibold text-xl mt-5">Uploaded Image</p>
            </div>
            <div className="col-12 md:col-6">
                <div className="mb-3">
                    <div className="field">
                        {imagePath ? (
                            <div className="col-12 md:col-12">
                                <img src={imagePath} alt="Branding" style={{ maxWidth: '100%', maxHeight: '300px', borderRadius: '8px' }} />
                            </div>
                        ) : (
                            <p className="text-center text-gray-500">No image available.</p>
                        )}
                    </div>
                </div>
            </div>
        </form>
    );
};

export default Branding;
